import { storeAwareness } from '../store/canvas-store';
import { colorFor } from './identity';
import type { PresencePeer } from './types';
import type { AgentStep } from '../agent/loop';

/**
 * The agent (Viv) has no socket of its own — the client running a turn carries
 * its presence in the local awareness state under the `agent` field, so every
 * peer (including the host) renders a Viv blob cursor while it works.
 */
export function setAgentWorking(frameId?: string): void {
  const aw = storeAwareness();
  if (!aw) return;
  const peer: PresencePeer = {
    id: 'viv', name: 'Viv', color: colorFor('viv'), initials: 'V', isAgent: true,
    selection: frameId,
  };
  aw.setLocalStateField('agent', peer);
}

export function clearAgentPresence(): void {
  storeAwareness()?.setLocalStateField('agent', null);
}

/** Best-effort frame id a tool step is acting on (frame.create uses `id`). */
export function stepFrameId(step: AgentStep): string | undefined {
  const f = step.input.frameId;
  if (typeof f === 'string' && f) return f;
  const id = step.input.id;
  if (typeof id === 'string' && id) return id;
  return undefined;
}
